export const APIConstant = {
  auth: {
    login: '/Auth/Login',
    contactUs: '/Auth/ContactUs',
    register: '/Auth/Register',
    verifyEmail: '/Auth/VerifyEmail',
    sendEmailVerificationCode: '/Auth/ResendEmailVerification',
    sendPasswordResetEmail: '/Auth/SendPasswordResetEmail',
    resetPassword: '/Auth/ResetPassword',
    changePassword: '/Auth/ChangePassword',
    updateProfile: '/Auth/UpdateProfile',
  },
  lookup: {
    appointmentType: '/Lookups/GetAppointmentTypes',
    userType: '/LookUps/GetLkUserTypes',
    agencies: '/LookUps/GetLkAgencies',
    agencyTypes: '/LookUps/GetLkAgencyTypes',
    state: '/LookUps/GetLkStates',
    stateWithLga: '/LookUps/GetLkStatesWithLgas',
    gender: '/LookUps/GetLkGenders',
    lga: '/LookUps/GetLkLgas',
    countries: '/LookUps/GetLkCountries',
    industries: '/LookUps/GetLkIndustries',
  },
  verify: {
    nin: '/Verify/VerifyNin',
    phone: '/Sms/SendVerifyCode',
    verifyCode: '/Sms/VerifyCode',
  },
  tenant: {
    create: '/Tenant/CreateTenants',
    createUsers: '/Tenant/CreateTenantUsers',
    update: '/Tenant/UpdateTenant',
    get: '/Tenant/GetAllTenants',
    getOne: '/Tenant/GetTenantProfile',
    delete: '/Tenant/DeleteTenant',
    deactivate: '/Tenant/DeactivateTenant',
    reactivate: '/Tenant/ReactivateTenant',
    getSettings: '/Tenant/GetTenantSettings',
    setSettings: '/Tenant/SetTenantSettings',
  },
  user: {
    createAdmins: '/User/CreateAdminUsers',
    updateAdmin: '/User/UpdateAdminUser',
    get: '/User/GetAllUsers',
    getOne: '/User/GetUserProfile',
    resetPassword: '/User/ResetPassword',
    assignNewPassword: '/User/AssignNewPassword',
    deleteUser: '/User/DeleteUser',
    deactivateUser: '/User/DeactivateUser',
    reactivateUser: '/User/ReactivateUser',
    updateProfile: '/User/UpdateProfile',
    getAllStaffDropdown: '/User/GetAllStaffDropdown',
    getStaffDepartmentOffice: '/User/GetStaffDepartmentOffice',
    assignStaffDepartmentOffice: '/User/AssignStaffDepartmentOffice',
  },
  role: {
    get: '/Role/GetAllRoles',
    getForCreateUser: '/Role/GetRolesForCreateUser',
    getForUserFilter: '/Role/GetRolesForUserFilter',
    create: '/Role/CreateRoles',
    delete: '/Role/DeleteRoles',
    assignRole: '/Role/AssignRoleToUsers',
    addUserClaims: '/Role/AddUserClaims',
    removeUserClaims: '/Role/RemoveUserClaims',
  },
  charts: {
    baseURL: 'http://my-json-server.typicode.com/apexcharts/apexcharts.js',
    paths: {
      yearly: '/yearly',
    },
  },
  visitor: {
    get: '/Visitors/GetAllVisitors',
    getOne: '/Visitors/GetVisitorById',
    getOneByPhone: '/Visitors/GetVisitorByPhone',
    checkin: '/Visitors/CheckIn',
    checkout: '/Visitors/CheckOut',
  },
  appointment: {
    get: '/Appointments/GetAllAppointments',
    getOne: '/Appointments/GetAppointmentById',
    checkin: '/Appointments/CheckIn',
    checkout: '/Appointments/CheckOut',
    create: '/Appointments/CreateAppointment',
    cancel: '/Appointments/Cancel',
  },
  visitingHours: {
    set: '/VisitingHours/SetVisitingHours',
    get: '/VisitingHours/GetVisitingHours',
  },
  department: {
    create: '/Departments/CreateDepartments',
    get: '/Departments/GetAllDepartments',
    getOne: '/Departments/GetDepartmentById',
    getDropdownList: '/Departments/GetDropDownList',
    update: '/Departments/UpdateDepartment',
    delete: '/Departments/DeleteDepartment',
    deactivateDepartments: '/Departments/DeactivateDepartments',
    reactivateDepartments: '/Departments/ReactivateDepartments',
  },
  dashboard: {
    getVisitorCards: '/Dashboard/GetVisitorDashboardCards',
    getAppointmentCards: '/Dashboard/GetAppointmentDashboardCards',
  },
  onboarding: {
    submitRequest: '/Onboarding/SubmitRequest',
    acceptRequest: '/Onboarding/AcceptRequest',
    rejectRequest: '/Onboarding/RejectRequest',
    resendWelcomeEmail: '/Onboarding/ResendWelcomeEmail',
    get: '/Onboarding/GetAllRequests',
    getOne: '/Onboarding/GetRequestById',
  },
  tag: {
    get: '/VisitorTags/GetAllTags',
    create: '/VisitorTags/CreateTags',
    getDropdownList: '/VisitorTags/GetDropdownList',
    getAllTenantTags: '/VisitorTags/GetAllTenantTags',
    getSingleTenantTag: '/VisitorTags/GetSingleTenantTag',
    deleteTag: '/VisitorTags/DeleteTag',
  },
  staff: {
    getAppointmentDashboardCards: '/Staff/GetAppointmentDashboardCards',
    getAllAppointments: '/Staff/GetAllAppointments',
    getSingleAppointment: '/Staff/GetSingleAppointment',
    createAppointment: '/Staff/CreateAppointment',
    cancelAppointment: '/Staff/CancelAppointment',
  }
};
